import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { RelatedPost } from '../types';

interface RelatedPostsProps {
  posts: RelatedPost[];
}

const RelatedPosts = ({ posts }: RelatedPostsProps) => {
  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="BookMarked" className="w-5 h-5 text-primary" />
        <h3 className="text-lg font-semibold text-text-primary">Related Articles</h3>
      </div>

      <div className="space-y-4">
        {posts.map((post) => (
          <Link
            key={post.id}
            to={`/blog/${post.slug}`}
            className="flex space-x-4 p-3 rounded-lg hover:bg-surface transition-colors duration-fast group"
          >
            <div className="relative w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden">
              <Image
                src={post.featuredImage}
                alt={post.featuredImageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-text-primary mb-2 line-clamp-2 group-hover:text-primary transition-colors duration-fast">
                {post.title}
              </h4>
              <div className="flex items-center space-x-3 text-xs text-text-secondary">
                <span className="px-2 py-0.5 bg-primary/10 text-primary rounded-full font-medium">
                  {post.category}
                </span>
                <div className="flex items-center space-x-1">
                  <Icon name="Clock" className="w-3 h-3" />
                  <span>{post.readTime} min</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedPosts;